import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';
import MobileMenu from '@/components/MobileMenu';
import NavLink from '@/components/NavLink';

function defaultLinks() {
  return [
    { to: "/", text: "Inicio" },
    { to: "/proceso-admision", text: "Proceso de admisión" },
    { to: "/nuestra-escuela", text: "Nuestra escuela" },
    { to: "/informaciones", text: "Informaciones" },
    
    // { to: "/galeria", text: "Galería" },
  ];
}

const socialLinks = [
  {
    href: "https://www.facebook.com/elarcoirisva",
    icon: faFacebookF,
    label: "Facebook de Escuela de Lenguaje Arcoíris",
  },
  {
    href: "https://www.instagram.com/elarcoiris_va/",
    icon: faInstagram,
    label: "Instagram de Escuela de Lenguaje Arcoíris",
  },
];

function SocialIcons({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {socialLinks.map(({ href, icon, label }) => (
        <a
          key={href}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="text-white hover:text-gray-300 transition-colors duration-200 hover:scale-110"
        >
          <FontAwesomeIcon icon={icon} size="lg" />
        </a>
      ))}
    </div>
  );
}

export default function Navbar({ links = defaultLinks() }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="w-full px-4 lg:px-6 h-16 flex items-center bg-blue-900 justify-between shadow-lg animate-fadeIn sticky top-0 z-50">
      {/* Logo */}
      <Link className="flex items-center" to="/">
        <img
          src="/images/Logo.png"
          alt="Logo Escuela de Lenguaje Arcoíris"
          width={70}
          height={80}
          className="mr-4 hover:rotate-3 transition-transform duration-300"
        />
      </Link>

      {/* Redes + menú (redes justo a la izquierda de Inicio) */}
      <div className="hidden sm:flex items-center gap-6 sm:gap-8 animate-slideDown">
        <SocialIcons />
        <nav className="flex gap-6 sm:gap-8">
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} text={link.text} />
          ))}
        </nav>
      </div>

      {/* Redes y menú hamburguesa en móvil */}
      <div className="flex items-center gap-4 sm:hidden">
        <SocialIcons />
        <button
          className="text-white hover:text-white transition-colors duration-200 focus:outline-none hover:scale-110"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={isMobileMenuOpen ? "Cerrar menú" : "Abrir menú"}
        >
          {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Menú desplegable para dispositivos móviles */}
      {isMobileMenuOpen && (
        <MobileMenu links={links} onClose={() => setIsMobileMenuOpen(false)} />
      )}
    </header>
  );
}
